<p-dialog
  [header]="editRestriction ? 'Edit Restriction' : 'Create Restriction'"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '90%'}"
  (onHide)="onDialogHide()"
>
  <div class="dialog-layout">
  <form
    [formGroup]="restrictionForm"
    class="p-fluid form-column"
    (submit)="$event.preventDefault()"
    (ngSubmit)="save($event)"
    novalidate
  >
    <!-- Name -->
    <div class="p-field">
      <label for="name">Name <span class="required">*</span></label>
      <input
        id="name"
        pInputText
        formControlName="name"
        [class.ng-invalid]="restrictionForm.get('name')?.invalid && restrictionForm.get('name')?.touched"
        [class.ng-dirty]="restrictionForm.get('name')?.dirty"
      />
      @if (restrictionForm.get('name')?.hasError('required') && restrictionForm.get('name')?.touched) {
        <div class="p-error">Name is required.</div>
      }
    </div>

    <!-- Vehicles & FPCs -->
    <div class="scope-selection-row">
      <div class="vehicle-selection">
        <label>Restricted vehicles <span class="required">*</span></label>
        <div class="vehicle-selected-list">
          @if (selectedVehicles.length) {
            <span class="vehicle-names">{{ selectedVehicleNames }}</span>
          } @else {
            <span class="vehicle-empty">No Vehicles selected</span>
          }
        </div>
        <app-vehicle-selector
          [(visible)]="vehicleDialogVisible"
          (onConfirm)="handleVehicleConfirm($event)"
          [selectedVehicles]="selectedVehicles">
        </app-vehicle-selector>
        <button pButton type="button" label="Add Vehicles" icon="pi pi-plus" (click)="onAddVehiclesClick($event)"></button>
        @if (restrictionForm.get('vehicles')?.hasError('required') && restrictionForm.get('vehicles')?.touched) {
          <div class="p-error">Please select at least one vehicle.</div>
        }
      </div>

      <div class="p-field fpc-selection">
        <label>FPC Specification</label>
        <div class="fpc-selected-list">
          @for (fpc of selectedFpcs; track fpc.fpcCode) {
            <div class="fpc-item">
              <span class="fpc-label">{{ fpcCodeDisplay(fpc.fpcCode) }} - {{ fpc.name }}</span>
              <button pButton type="button" icon="pi pi-trash" class="p-button-text fpc-remove-btn" (click)="removeFpc(fpc)"></button>
            </div>
          } @empty {
            <span class="fpc-empty">No FPCs selected</span>
          }
        </div>
        <app-category-selector
          [(visible)]="categoryDialogVisible"
          [selectedFpcs]="selectedFpcs"
          (onConfirm)="handleCategoryConfirm($event)">
        </app-category-selector>
        <button pButton type="button" label="Add FPCs" icon="pi pi-plus" (click)="categoryDialogVisible = true"></button>
      </div>
    </div>

    <!-- Toggles -->
    <div class="p-field">
      <div class="switches">
        <div class="p-field">
          <label for="banTestTrack">Ban Test Track</label><br />
          <p-toggleswitch id="banTestTrack" formControlName="banTestTrack"></p-toggleswitch>
        </div>
        <div class="p-field">
          <label for="banOpenRoad">Ban Open Road</label><br />
          <p-toggleswitch id="banOpenRoad" formControlName="banOpenRoad"></p-toggleswitch>
        </div>
      </div>
    </div>

    <!-- Dates & Text --> 
    <div class="p-field">
      <label for="validRange">Valid Period <span class="required">*</span></label>
      <div class="week-selectable" (click)="onCalendarClick($event)">
        <p-datepicker
          id="validRange"
          formControlName="validRange"
          selectionMode="range"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          [showWeek]="true"
          [firstDayOfWeek]="1"
          [placeholder]="'Select date range'">
        </p-datepicker>
      </div>
      <small class="week-hint">Tip: click a week number to select a whole week. Click a second week number to set the end of the range.</small>
    </div>
    <div class="p-field">
      <label for="approvedBy">Restriction contact information <span class="required">*</span></label>
      <p-editor formControlName="approvedBy" [style]="{'height':'180px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('approvedBy')?.hasError('contentRequired') && restrictionForm.get('approvedBy')?.touched) {
        <div class="p-error">Please fill in the restriction contact information.</div>
      }
    </div>
    <div class="p-field">
      <label for="causing">Causing Part <span class="required">*</span></label>
      <p-editor formControlName="causing" [style]="{'height':'200px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('causing')?.hasError('contentRequired') && restrictionForm.get('causing')?.touched) {
        <div class="p-error">Please fill in the causing part details.</div>
      }
    </div>
    <div class="p-field">
      <label for="risk">Why is there a Risk <span class="required">*</span></label>
      <p-editor formControlName="risk" [style]="{'height':'180px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('risk')?.hasError('contentRequired') && restrictionForm.get('risk')?.touched) {
        <div class="p-error">Please fill in the risk information.</div>
      }
    </div>
    <div class="p-field">
      <label for="consequence">What consequence/risks are there? <span class="required">*</span></label>
      <p-editor formControlName="consequence" [style]="{'height':'250px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('consequence')?.hasError('contentRequired') && restrictionForm.get('consequence')?.touched) {
        <div class="p-error">Please fill in the consequence/risk details.</div>
      }
    </div>
    <div class="p-field">
      <label for="precondition">Who can use the vehicles with the risk stated and/or what knowledge is needed? <span class="required">*</span></label>
      <p-editor formControlName="precondition" [style]="{'height':'220px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('precondition')?.hasError('contentRequired') && restrictionForm.get('precondition')?.touched) {
        <div class="p-error">Please add content to this field beyond the template text.</div>
      }
    </div>
    <div class="p-field">
      <label for="operatedRestriction">How can vehicles be operated with this restriction: <span class="required">*</span></label>
      <p-editor formControlName="operatedRestriction" [style]="{'height':'250px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('operatedRestriction')?.hasError('contentRequired') && restrictionForm.get('operatedRestriction')?.touched) {
        <div class="p-error">Please add content to this field beyond the template text.</div>
      }
    </div>
    <div class="p-field">
      <label for="removingCondition">When can this risk be removed? <span class="required">*</span></label>
      <p-editor formControlName="removingCondition" [style]="{'height':'200px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
      @if (restrictionForm.get('removingCondition')?.hasError('contentRequired') && restrictionForm.get('removingCondition')?.touched) {
        <div class="p-error">Please add content to this field beyond the template text.</div>
      }
    </div>

    <div class="uploads">
      <app-file-upload
        #pictureUploader
        [addFileLabel]="'Add Picture'"
        accpetType="image/*"
        [initialFiles]="initialPictureFiles"
        (fileChanged)="onUpload($event, 'pictures')"
      ></app-file-upload>
      <app-file-upload
        #documentUploader
        [addFileLabel]="'Add Document'"
         accpetType=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rtf,.txt,.xml,application/xml,text/xml"
        [initialFiles]="initialDocumentFiles"
        (fileChanged)="onUpload($event, 'documents')"
      ></app-file-upload>
      <div class="p-field">
        <app-link-list
          #linkListRef
          [initialLinks]="restrictionForm.value.links || []"
          [addUrlLabel]="'Add Link'"
          [placeholder]="'https://example.com'"
          (linksChanged)="onLinksChanged($event)">
        </app-link-list>
      </div>
    </div>

    <div class="p-field">
      <label for="additionalInformation">Additional Information</label>
      <p-editor formControlName="additionalInformation" [style]="{'height':'280px'}">
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small">Small</option>
              <option selected>Normal</option>
              <option value="large">Large</option>
              <option value="huge">Huge</option>
            </select>
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
          </span>
        </ng-template>
      </p-editor>
    </div>

    <div class="p-dialog-footer">
      <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-secondary" (click)="close()"></button>
      @if (editRestriction) {
        <button pButton type="button" label="End Restriction" icon="pi pi-trash" class="p-button-warning" (click)="endRestriction()"></button>
      } @else {
        <button pButton type="button" label="Clear" icon="pi pi-trash" class="p-button-warning" (click)="clear()"></button>
      }
      <button pButton type="submit" label="Save"  icon="pi pi-check"  [loading]="saving"  [disabled]="restrictionForm.invalid || saving"> </button>
    </div>

  </form>

  </div>
</p-dialog>

<p-dialog
  header="End Restriction"
  [(visible)]="showEndRestrictionConfirmDialog"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '450px' }"
>
  <div class="dialog-content">
    <i class="pi pi-exclamation-triangle warning-icon"></i>
    <span class="dialog-message">
      You are about to end restriction called <strong>{{ editRestriction?.restrictionName }}</strong>, are you sure?
    </span>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton type="button" label="Cancel" (click)="cancelEndRestriction()"></button>
      <button pButton type="button" label="Ok" class="p-button-warning" (click)="confirmEndRestriction()"></button>
    </div>
  </ng-template>
</p-dialog>
